export default "__VITE_ASSET__RZbDWYjx__"